<template>
  <div class="row">
    <div class="col-md-12">
      <div id="ecoMap">
        <div class="splited-map" 
          v-for="n in 600" 
          :key="n"  
          :style="{ 'background-image': 'url(' + getImageUrls(n) + ')' }"
          :title="'Khu ' + n"
          @click="openControlDevicesPanel(n)">
        </div>
      </div>
    </div>
    <DeviceListModal
            v-bind:areaIndex="areaIndex"
            v-bind:tableData="tableData">
    </DeviceListModal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import DeviceListModal from './DeviceListModal.vue'

  export default {
    components: {
      DeviceListModal
    },
  
    data () {
      return{
        isShowing: false,
        areaIndex: 15,
        tableData: [{
          name: 'A28-008',
          parent: 'Node 28',
          setuptime: '09/06/2019',
          active: false
        }, {
          name: 'A07-010',
          parent: 'Node 07',
          setuptime: '09/06/2019',
          active: true
        }]
      }
    },
    methods: {
     getImageUrls(index) {
        //var images = require.context('./static/img/maps/', false, /\.png$/)
        if(index < 10) return ('static/img/maps/image_part_00' + index + ".png")
        if(index < 100) return ('static/img/maps/image_part_0' + index + ".png")
        return ('static/img/maps/image_part_' + index + ".png")
      },
      openControlDevicesPanel(index) {
        this.areaIndex = index;
        // todo: call axios get data to fill in this.tableData 
          
        //
        document.getElementById('device_list').style.display='block';
      }
    },
    async mounted() {
      
    }
  }
</script>
<style>
  #ecoMap {
    width:780px;
    height: 775px;
    background-color: #cccccc;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
  }
  .splited-map{
    width: 38px;
    height: 26px;
    border: 0.5px solid black;
    transition: transform .2s;
    z-index: 1;
    cursor: pointer;
    float:left;
    background-size: cover;
  }
  .splited-map:hover{
    border: 1px solid red;
    transform: scale(1.5);
    box-shadow: 0 4px 2px -2px rgba(0, 140, 186, 0.5);
  }
</style>
-